<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title">
        Add Document
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small @click="closePanel" color="primary">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-layout>
        <v-flex xs12>
          <v-form>
            <v-text-field
              :error-messages="messages.title"
              v-model="doc.title"
              label="Document Title"
              type="text"
              filled
            >
            <template slot="append-outer">
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on">fa fa-question</v-icon>
               </template>
               <span>Enter document title</span>
              </v-tooltip>
            </template>
            </v-text-field>
            <v-textarea
              v-model="doc.description"
              label="Description"
              hint="Enter a description for this document"
              filled
            >
            <template slot="append-outer">
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on">fa fa-question</v-icon>
               </template>
               <span>Enter a description for this document</span>
              </v-tooltip>
            </template>
            </v-textarea>
            <drop-zone
              :type="type"
              :accepted="accepted"
              :maxFilesize=20
              class="mt-5 dropzone-container"
            ></drop-zone>
            <label v-if="messages.file"
            :error-messages="messages.file" class="v-messages theme--light error--text">{{ messages.file[0] }}</label>
            <template>
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on" class="dropzone-help">fa fa-question</v-icon>
               </template>
               <span>Click here to upload a file</span>
              </v-tooltip>
            </template>
            <p class="block text-left mt-4 caption">
              Max upload filesize: 20MB <br />
              Accepted file formats: pdf, doc, docx, xls, xlsx
            </p>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer   height="68">
      <v-flex  text-right>
        <v-btn v-if="!s3Uploading || !loading"  :color="$store.getters.partner ? 'primary': 'grey300'" @click="closePanel"
          >Cancel</v-btn> 
        <v-btn v-if="s3Uploading || loading" color="primary" class="ml-2" loading></v-btn>
        <v-btn v-else :color="$store.getters.partner ? 'primary': 'dark-blue'" :class="['ml-2', $store.getters.partner ? '' : 'add-course-button']"  @click="addDocument"
          >Add Document</v-btn
        >
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import DropZone from "@/components/global/Dropzone";
import courseAPI from "@/api/course.js";
export default {
  name: "AddDocument",
  components: {
    DropZone
  },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  data: () => ({
    doc: {},
    messages: {},
    accepted:
      "application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    loading: false,
    type: "document",
    successMessage: "Document Successfully Added.",
    errorMessage:
      "Oops, something went wrong! Please check information is correct."
  }),
  computed: {
    s3Uploading() {
      return this.$store.getters.s3Uploading;
    }
  },
  mounted() {
    this.$store.dispatch("setS3Uploading", false);
    this.doc.courseId = this.id;
  },
  methods: {
    closePanel() {
      this.$emit("closePanel", {});
    },
    addDocument() {
      this.loading = true;
      courseAPI
        .addDocument(
          this.doc,
          this.$store.getters.s3Url,
          this.$store.getters.fileDetails
        )
        .then(resp => {
          this.closePanel();
          this.$store.dispatch("addCourseMaterials", resp.data.data);
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(err => {
          this.valid = false;
          this.$snotify.error(this.errorMessage);
          this.messages = this.$gf.errorResponse(err);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    }
  }
};
</script>
